import { useState, useEffect } from "react";
import Select from "react-select";
import {
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
} from "@mui/material";
import Generate from "./Generate";
import "../../Pricing.css";
import { Auth } from "aws-amplify";
import PortfolioRiskSidebar from "./PortfolioRiskSidebar";



const Pricing = () => {
  const [cropName, setCropName] = useState("Maize");
  const [cropVariety, setCropVariety] = useState("");
  const [marketName, setMarketName] = useState(["Gulabbagh"]);
  const [priceSource, setPriceSource] = useState("NCDEX");
  const [priceUnit, setPriceUnit] = useState("Rs/Quintal");
  const [strikeMethod, setstrikeMethod] = useState("Average");
  const [StrikeStartDate, setStrikeStartDate] = useState("");
  const [error, setError] = useState("");
  const [StrikeEndDate, setStrikeEndDate] = useState("");
  const [monitoringStartDate, setMonitoringStartDate] = useState("");
  const [monitoringEndDate, setMonitoringEndDate] = useState("");
  const [strikePrice, setStrikePrice] = useState("");
  const [exitPrice, setExitPrice] = useState("");
  const [deTrendData, setDeTrendData] = useState("no");
  const [showGenerate, setShowGenerate] = useState(false); // State to control Generate component visibility
  const [generateclicked, setgenerateclicked] = useState(1); // State to control Generate component visibility
  const [endDateError1, setEndDateError1] = useState(false);
  const [endDateError2, setEndDateError2] = useState(false);
  const [historicalPrices, setHistoricalPrices] = useState([]); // New state for historical price data
  const [editedHistoricalPrices, setEditedHistoricalPrices] = useState([]); // State to store edited prices
  const [currentStrikePrice, setcurrentStrikePrice] = useState("");
  const [insuranceType, setInsuranceType] = useState("Post-Harvest");
  const [movingAvgWindow, setmovingAvgWindow] = useState(null);
  const [postHarvestSelected, setpostHarvestSelected] = useState(true);
  const [bucketWindow] = useState(1);
  const [typeofRisk, settypeofRisk] = useState("Downside");
  const [cropOptions, setCropOptions] = useState([]);
  const [marketOptions, setMarketOptions] = useState([]);
  const [sourceOptions, setSourceOptions] = useState([]);
  const [outlierPercentage, setOutlierPercentage] = useState(null);
  const [strikeAdjustmentRatio, setStrikeAdjustmentRatio] = useState(0);
  const [tabValue,setTabValue] = useState(0)

  const insurance_type_options = [
    { value: "Sowing", label: "Sowing" },
    { value: "Post-Harvest", label: "Post-Harvest" },
  ];


  const handleStartDateChange = (e) => {
    const selectedStartDate = e.target.value;
    setMonitoringStartDate(selectedStartDate);
    if (monitoringEndDate) {
      if (new Date(selectedStartDate) < new Date(monitoringEndDate))
        setEndDateError1(false);
      else
        setEndDateError1(true);
    }
  };


  const handleEndDateChange = (e) => {
    const selectedEndDate = e.target.value;
    setMonitoringEndDate(selectedEndDate);

    if (monitoringStartDate) {
      if (new Date(monitoringStartDate) < new Date(selectedEndDate))
        setEndDateError1(false);
      else
        setEndDateError1(true);
    }
  };


  const handleStrikeStartDateChange = (e) => {
    const selectedStartDate = e.target.value;
    setStrikeStartDate(selectedStartDate);

    if (StrikeEndDate) {
      if (new Date(selectedStartDate) < new Date(StrikeEndDate))
        setEndDateError2(false);
      else
        setEndDateError2(true);
    }
  };


  const handleStrikeEndDateChange = (e) => {
    const selectedEndDate = e.target.value;
    setStrikeEndDate(selectedEndDate);

    if (StrikeStartDate) {
      if (new Date(StrikeStartDate) < new Date(selectedEndDate))
        setEndDateError2(false);
      else
        setEndDateError2(true);
    }
  };

  const isFormValid =
    cropName &&
    marketName &&
    StrikeStartDate &&
    StrikeEndDate &&
    priceSource &&
    monitoringStartDate &&
    monitoringEndDate &&
    exitPrice &&
    priceUnit;

  const handleClear = () => {
    setCropName(null);
    setCropVariety(null);
    setMarketName([]);
    setPriceSource(null);
    setMonitoringStartDate("");
    setMonitoringEndDate("");
    setStrikePrice("");
    setStrikeStartDate("");
    setStrikeEndDate("");
    setExitPrice("");
    setDeTrendData("no");
    setShowGenerate(false);
    setgenerateclicked(1);
    setHistoricalPrices([]);
    setEditedHistoricalPrices([]);
    setcurrentStrikePrice("");
    setInsuranceType("");
    setmovingAvgWindow(null);
  };

  const handleGenerateStrikePrice = async () => {
    const { accessToken: { jwtToken } } = await Auth.currentSession();

    if (isFormValid) {
      try {
        // Prepare the request body
        const requestBody = {
          start_date: (StrikeStartDate),
          end_date: (StrikeEndDate),
          source: priceSource,
          commodity: cropName,
          market_names: marketName,
          strike_price_type: strikeMethod,
          strike_adjustment_ratio: strikeAdjustmentRatio,
          risk_type: typeofRisk
        };

        // Use fetch to call the API
        const response = await fetch("/api/pricing/historicalStrikePrice", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": jwtToken,
          },
          body: JSON.stringify(requestBody),
        });

        // Parse the response
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const resultData = await response.json();
        setStrikePrice(resultData.strike_price);
        setHistoricalPrices(resultData); // Set the data from the API response
        if (resultData.length !== 0) {
          setEditedHistoricalPrices(resultData);
        } else {
          setEditedHistoricalPrices([]);
        }
      } catch (error) {
        setHistoricalPrices([]);
        console.error("Error fetching strike price:", error);
        setEditedHistoricalPrices([]);
      }
    }
  };


  const handleGenerate = async () => {
    if (isFormValid) {
      try {
        if (editedHistoricalPrices.length === 0)
          handleGenerateStrikePrice()
        // Set states after successful API call
        setShowGenerate(true);
        setgenerateclicked((prev) => prev + 1);
      } catch (error) {
        console.error("Error fetching strike price:", error);
      }
    }
  };

  useEffect(() => {
    // Logic to generate historical strike price table
    handleGenerateStrikePrice()
    // eslint-disable-next-line
  }, [
    StrikeStartDate,
    StrikeEndDate,
    priceSource,
    cropName,
    marketName,
    strikeMethod,
    insuranceType,
    cropVariety,
    strikeAdjustmentRatio,
    typeofRisk
  ]);


  const handlePriceChange = (index, newValue) => {
    setEditedHistoricalPrices((prevPrices) => {
      const updatedPrices = [...prevPrices];
      updatedPrices[index].price = newValue;
      return updatedPrices;
    });
  };

  const handleWeightChange = (index, newValue) => {
    setEditedHistoricalPrices((prevPrices) => {
      const updatedPrices = [...prevPrices];
      updatedPrices[index].weight = newValue;
      return updatedPrices;
    });
  };

  // Fetch Crop Names
  useEffect(() => {
    const fetchCropNames = async () => {
      try {
        const { accessToken: { jwtToken } } = await Auth.currentSession();
        const response = await fetch("/api/pricing/getCropName", {
          headers: {
            Authorization: jwtToken,
          },
        });
        const data = await response.json();
        const formattedOptions = data.crops.map((crop) => ({
          label: crop,
          value: crop,
        }));
        setCropOptions(formattedOptions);
      } catch (error) {
        console.error("Error fetching crop names:", error);
      }
    };
    fetchCropNames();
  }, []);

  console.log(tabValue)


  // Fetch Price Sources
  useEffect(() => {
    if (cropName) {
      const fetchPriceSources = async () => {
        try {
          const { accessToken: { jwtToken } } = await Auth.currentSession();
          let requestBody = {
            crop_name: cropName
          }
          const response = await fetch(
            `/api/pricing/getSourceName`,
            {
              method: "POST",
              headers: {
                Authorization: jwtToken,
                "Content-Type": "application/json",
              },
              body: JSON.stringify(requestBody)
            }
          );
          const data = await response.json();
          const formattedOptions = data.map((source) => ({
            label: source._id,
            value: source._id,
          }));
          setSourceOptions(formattedOptions);
        } catch (error) {
          console.error("Error fetching price sources:", error);
        }
      };
      fetchPriceSources();
    } else {
      setSourceOptions([]);
    }
  }, [cropName]);


  useEffect(() => {
      const fetchMarketNames = async () => {
        try {
          const { accessToken: { jwtToken } } = await Auth.currentSession();
          const response = await fetch(
            `/api/pricing/getMarketVarietyName?crop_name=${encodeURIComponent(cropName)}&source_name=${priceSource}`,
            {
              headers: {
                Authorization: jwtToken,
              },
            }
          );
          const data = await response.json();
          const formattedOptions = data.map((market) => ({
            label: market["market_variety_combination"],
            value: market["market_variety_combination"]
          }));
          setMarketOptions(formattedOptions);
          setMarketName([]);
        } catch (error) {
          console.error("Error fetching market names:", error);
          setMarketName([])
        }
      };
      fetchMarketNames();
  }, [cropName, priceSource]);



  return (
    <div className="compare-pannel">
     {tabValue === 2?(<PortfolioRiskSidebar/>):(
      <div>
        <div className="exploretext">Premium Calculation</div>
        <div className="compareecondarytext">
          Fill the required input fields to calculate the pure premium
        </div>
        <div className="download-container">
          <h2 className="select-label">
            Crop Name
          </h2>
          <Select
            className="custom-select"
            placeholder="Crop Name"
            value={cropName ? { label: cropName, value: cropName } : null}
            onChange={(selectedOption) => {
              setCropName(selectedOption.value);
              setMarketName([]);
              setPriceSource(null);
            }}
            options={cropOptions}
          />
        </div>
        <div className="download-container">
          <h2 className="select-label">
            Price Source
          </h2>
          <Select
            className="custom-select"
            placeholder="Price Source"
            value={
              priceSource ? { label: priceSource, value: priceSource } : null
            }
            onChange={(selectedOption) => setPriceSource(selectedOption.value)}
            options={sourceOptions}
            isDisabled={!cropName}
          />
        </div>

        <div className="download-container">
          <h2 className="select-label">
            Market - Variety Name
          </h2>
          <Select
            className="custom-select"
            placeholder="Market - Variety Name"
            value={marketName.map(value => ({ value, label: marketOptions.find(opt => opt.value === value)?.label || value }))} // Set the value
            onChange={(selectedOption) => {
              let marketArray = selectedOption.filter(item => typeof item === 'object' && item !== null && 'value' in item).map(item => item.value);
              setMarketName(marketArray || [])
            }}
            options={marketOptions}
            isDisabled={!cropName || !priceSource}
            isMulti
            getOptionLabel={(option) => option.label} // Display the label
            getOptionValue={(option) => option.value} // Store the value
          />
        </div>


        <div className="download-container">
          <h2 className="select-label">
            Type of Insurance <span className="mandatory"></span>
          </h2>
          <Select
            className="custom-select"
            options={insurance_type_options}
            placeholder="Type of Insurance"
            onChange={(obj) => {
              setInsuranceType(obj.value);
              setEditedHistoricalPrices([]);
              setpostHarvestSelected(obj.value === "Post-Harvest"); // Update based on selection
            }}
          />
        </div>
        {insuranceType === "Post-Harvest" && (
          <div className="download-container">
            <div className="date-item">
              <h2 className="select-label">
                Moving Average Window (Days(1-30)){" "}
              </h2>
              <TextField
                id="strikePricepercentile"
                fullWidth
                InputLabelProps={{ shrink: true }}
                type="number"
                error={!!error}
                helperText={error}
                onChange={(e) => {
                  const value = parseInt(e.target.value, 10);
                  if (!Number.isInteger(value) || value < 1 || value > 30) {
                    setError("Please enter an integer between 1 and 30.");
                    setmovingAvgWindow(""); // Clear the state if input is invalid
                  } else {
                    setError(""); // Clear the error if input is valid
                    setmovingAvgWindow(value);
                  }
                }}
                sx={{
                  margin: "4px 0",
                  ".MuiInputBase-root": { height: "45px", fontSize: "14px" },
                }}
              />
            </div>
          </div>
        )}
        <div className="download-container">
          <h2 className="select-label">
            Type of Risk
          </h2>
          <Select
            className="custom-select"
            placeholder="Type of risk"
            value={typeofRisk ? { label: typeofRisk, value: typeofRisk } : null}
            onChange={(selectedOption) => settypeofRisk(selectedOption.value)}
            options={[
              { value: "Upside", label: "Upside" },
              { value: "Downside", label: "Downside" },
            ]}
          />
        </div>
       
        <div className="download-container">
          <h2 className="select-label">
            Monitoring Duration
          </h2>
          <div className="date-row">
            <div className="date-item">
              <h2 className="date-label">Start Date</h2>
              <TextField
                id="monitoringStartDate"
                type="date"
                fullWidth
                InputLabelProps={{ shrink: true }}
                value={monitoringStartDate}
                onChange={handleStartDateChange}
                sx={{
                  margin: "4px 0",
                  ".MuiInputBase-root": { height: "45px", fontSize: "14px" },
                }}
              />
            </div>
            <div className="date-item">
              <h2 className="date-label">End Date</h2>
              <TextField
                id="monitoringEndDate"
                type="date"
                fullWidth
                InputLabelProps={{ shrink: true }}
                value={monitoringEndDate}
                onChange={handleEndDateChange}
                error={endDateError1} // Shows red border if there's an error
                helperText={
                  endDateError1
                    ? "End Date cannot be earlier than Start Date"
                    : ""
                }
                sx={{
                  margin: "4px 0",
                  ".MuiInputBase-root": {
                    height: "45px",
                    fontSize: "14px",
                    borderColor: endDateError1 ? "red" : "inherit",
                  },
                }}
              />
            </div>


          </div>
        </div>
        <div className="download-container">
          <h2 className="select-label">
            Peak Harvest Period
          </h2>

          <div className="date-row">
            <div className="date-item">
              <h2 className="date-label">Start Date</h2>
              <TextField
                id="StrikeStartDate"
                type="date"
                fullWidth
                InputLabelProps={{ shrink: true }}
                value={StrikeStartDate}
                onChange={handleStrikeStartDateChange}
                sx={{
                  margin: "4px 0",
                  ".MuiInputBase-root": { height: "45px", fontSize: "14px" },
                }}
              />
            </div>
            <div className="date-item">
              <h2 className="date-label">End Date</h2>
              <TextField
                id="StrikeEndDate"
                type="date"
                fullWidth
                InputLabelProps={{ shrink: true }}
                value={StrikeEndDate}
                onChange={handleStrikeEndDateChange}
                error={endDateError2}
                helperText={
                  endDateError2
                    ? "End Date cannot be earlier than Start Date"
                    : ""
                }
                sx={{
                  margin: "4px 0",
                  ".MuiInputBase-root": {
                    height: "45px",
                    fontSize: "14px",
                    borderColor: endDateError2 ? "red" : "inherit",
                  },
                }}
              />
            </div>
          </div>
        </div>
        <div className="download-container">
          <h2 className="select-label">
            Price Unit
          </h2>
          <Select
            className="custom-select"
            placeholder="Price unit"
            value={priceUnit ? { label: priceUnit, value: priceUnit } : null}
            onChange={(selectedOption) => setPriceUnit(selectedOption.value)}
            options={[
              { value: "Rs/Quintal", label: "Rs/Quintal" },
              { value: "Rs/kg", label: "Rs/kg" },
            ]}
          />
        </div>
        <div className="download-container">
          <div className="date-row">
            <div className="date-item">
              <h2 className="select-label">
                Current Strike Price
              </h2>
              <TextField
                id="StrikePrice"
                type="number"
                fullWidth
                InputLabelProps={{ shrink: true }}
                value={currentStrikePrice}
                onChange={(e) => setcurrentStrikePrice(e.target.value)}
                sx={{
                  margin: "4px 0",
                  ".MuiInputBase-root": { height: "45px", fontSize: "14px" },
                }}
              />
            </div>
            <div className="date-item">
              <h2 className="select-label">
                Current Exit Price
              </h2>
              <TextField
                id="exitPrice"
                type="number"
                fullWidth
                InputLabelProps={{ shrink: true }}
                value={exitPrice}
                onChange={(e) => setExitPrice(e.target.value)}
                sx={{
                  margin: "4px 0",
                  ".MuiInputBase-root": { height: "45px", fontSize: "14px" },
                }}
              />
            </div>
          </div>
        </div>

        <h2 className="select-label">
          Strike Discount %
        </h2>
        <TextField
          id="strikeAdjustmentRatio"
          type="number"
          fullWidth
          InputLabelProps={{ shrink: true }}
          value={strikeAdjustmentRatio}
          onChange={(e) => setStrikeAdjustmentRatio(e.target.value)}
          sx={{
            margin: "4px 0",
            ".MuiInputBase-root": { height: "45px", fontSize: "14px" },
          }}
        />

        <div className="download-container" style={{ marginBottom: "80px", marginTop: '15px' }}>
          <div className="date-row">
            <div className="date-item">
              <h2 className="select-label">Enable Daily Price Tolerance</h2>
              <RadioGroup
                row
                value={deTrendData}
                onChange={(event) => { setDeTrendData(event.target.value) }}
              >
                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="No" control={<Radio />} label="No" />
              </RadioGroup>
            </div>
          </div>
          {deTrendData === "Yes" ? (<div className="date-item">
            <h2 className="select-label" style={{ marginTop: "20px" }}>
              Daily Price Tolerance %
            </h2>
            <TextField
              id="outlierPercentage"
              type="number"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={outlierPercentage}
              onChange={(e) => setOutlierPercentage(e.target.value)}
              sx={{
                margin: "4px 0",
                ".MuiInputBase-root": { height: "45px", fontSize: "14px" },
              }}
            />
          </div>
          ) : ('')}

        </div>
        {historicalPrices.length > 0 && (
          <div className="download-container" style={{ marginBottom: "120px" }}>
            <h2 className="select-label">Historical Strike Prices</h2>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                    Year
                  </th>
                  <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                    Price
                  </th>
                  <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                    Adjusted Price
                  </th>
                  <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                    Weight
                  </th>
                </tr>
              </thead>
              <tbody>
                {editedHistoricalPrices.map((item, index) => (
                  <tr key={index}>
                    <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                      {item.year}
                    </td>
                    <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                      <input
                        type="number"
                        value={item.old_price}
                        onChange={(e) =>
                          handlePriceChange(index, parseFloat(e.target.value))
                        }
                        style={{ width: "100%" }}
                      />
                    </td>
                    <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                      <input
                        type="number"
                        value={item.price}
                        onChange={(e) =>
                          handlePriceChange(index, parseFloat(e.target.value))
                        }
                        style={{ width: "100%" }}
                      />
                    </td>
                    <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                      <input
                        type="number"
                        value={item.weight}
                        onChange={(e) =>
                          handleWeightChange(index, parseFloat(e.target.value))
                        }
                        style={{ width: "100%" }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        <div
          className="button-container"
          style={{
            position: "fixed",
            bottom: "0",
            width: "380px",
            backgroundColor: "white",
            zIndex: "1000",
            padding: "15px 20px",
            display: "flex",
            justifyContent: "flex-end",
            borderTop: "1px solid #ccc",
          }}
        >
          <Button
            variant="contained"
            style={{
              backgroundColor: "#F1F5F9",
              color: "#000",
              marginRight: "20px",
            }}
            onClick={handleClear}
          >
            Clear
          </Button>

          <Button
            variant="contained"
            style={{
              backgroundColor: isFormValid ? "#0880EA" : "#ccc",
              color: "#fff",
            }}
            //disabled={!isFormValid}
            onClick={handleGenerate}
          >
            Generate Output
          </Button>
        </div>
      </div>
      )}

      {showGenerate && (
        <div
          className="generate-panel"
          style={{
            position: "fixed",
            right: "0",
            top: "0",
            width: "calc(100vw - 470px)",
            height: "100vh",
            backgroundColor: "#fff",
            zIndex: "1000",
            padding: "24px",
            borderLeft: "1px solid rgba(26, 26, 0, 0.16)",
            overflow: "auto",
            marginTop: "40px",
          }}
        >
          <Generate
            showGenerate={showGenerate}
            cropName={cropName}
            cropVariety={cropVariety}
            monitoringStartDate={monitoringStartDate}
            monitoringEndDate={monitoringEndDate}
            strikePrice={strikePrice}
            exitPrice={exitPrice}
            currentStrikePrice={currentStrikePrice}
            priceSource={priceSource}
            priceUnit={priceUnit}
            marketName={marketName}
            generateclicked={generateclicked}
            editedHistoricalPrices={editedHistoricalPrices}
            postHarvestSelected={postHarvestSelected}
            insuranceType={insuranceType}
            movingAvgWindow={movingAvgWindow}
            bucketWindow={bucketWindow}
            typeofRisk={typeofRisk}
            outlier_percentage={outlierPercentage}
            outlier_status={deTrendData}
            strikeAdjustmentRatio={strikeAdjustmentRatio}
            setTabValue={e=>setTabValue(e)}
          />
        </div>
      )}
    </div>
  );
};

export default Pricing;
